import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'

const LANGUAGES: string[] = [
    'fr',
    'af',
    'am',
    'ar',
    'as',
    'az',
    'ba',
    'be',
    'bg',
    'bho',
    'bn',
    'bo',
    'brx',
    'bs',
    'ca',
    'cs',
    'cy',
    'da',
    'de',
    'doi',
    'dsb',
    'dv',
    'el',
    'en',
    'es',
    'es-MX',
    'et',
    'eu',
    'fa',
    'fi',
    'fil',
    'fj',
    'fo',
    'fr-CA',
    'ga',
    'gl',
    'gom',
    'gu',
    'ha',
    'he',
    'hi',
    'hne',
    'hr',
    'hsb',
    'ht',
    'hu',
    'hy',
    'id',
    'ig',
    'ikt',
    'is',
    'it',
    'iu',
    'iu-Latn',
    'ja',
    'ka',
    'kk',
    'km',
    'kmr',
    'kn',
    'ko',
    'ks',
    'ku',
    'ky',
    'lb',
    'ln',
    'lo',
    'lt',
    'lug',
    'lv',
    'lzh',
    'mai',
    'mg',
    'mi',
    'mk',
    'ml',
    'mn-Cyrl',
    'mn-Mong',
    'mni',
    'mr',
    'ms',
    'mt',
    'mww',
    'my',
    'nb',
    'ne',
    'nl',
    'nso',
    'nya',
    'or',
    'otq',
    'pa',
    'pl',
    'prs',
    'ps',
    'pt',
    'pt-PT',
    'ro',
    'ru',
    'run',
    'rw',
    'sd',
    'si',
    'sk',
    'sl',
    'sm',
    'sn',
    'so',
    'sq',
    'sr-Cyrl',
    'sr-Latn',
    'st',
    'sv',
    'sw',
    'ta',
    'te',
    'th',
    'ti',
    'tk',
    'tlh-Latn',
    'tlh-Piqd',
    'tn',
    'to',
    'tr',
    'tt',
    'ty',
    'ug',
    'uk',
    'ur',
    'uz',
    'vi',
    'xh',
    'yo',
    'yua',
    'yue',
    'zh-Hans',
    'zh-Hant',
    'zu'
]

i18n.use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'fr',
        supportedLngs: LANGUAGES,
        debug: import.meta.env.DEV,
        backend: {
            loadPath: '/locales/{{lng}}.json',
            requestOptions: {
                cache: 'default'
            }
        },
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['localStorage', 'sessionStorage'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng'
        },
        react: {
            useSuspense: false
        }
    })

export default i18n
